import { isEqual, omit } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from '../../Elements';
import styles from './InputWithSuggestions.scss';
import Suggestion from './Suggestion';

class InputWithSuggestions extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.exact({
        title: PropTypes.string,
        description: PropTypes.string,
        value: PropTypes.string.isRequired
      })
    ).isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: -1,
      showSuggestions: false
    };
    this.suggestionsContainer = React.createRef();
    this.updateRefs();
    this.onChange = this.onChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.filteredOptions = this.filteredOptions.bind(this);
    this.hideSuggestions = this.hideSuggestions.bind(this);
    this.showSuggestions = this.showSuggestions.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.updateRefs = this.updateRefs.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.options, this.props.options)) {
      this.updateRefs();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  onChange(e, value) {
    this.props.onChange(e, { value, name: this.props.name });
  }

  onInputChange(e) {
    this.setState({ selectedOptionIndex: -1, showSuggestions: true });
    this.onChange(e, e.target.value);
    this.updateRefs();
  }

  onKeyDown(e) {
    if (e.key === 'ArrowUp') {
      this.moveCursor(-1);
    } else if (e.key === 'ArrowDown') {
      this.moveCursor(1);
    } else if (e.key === 'Enter') {
      const options = this.filteredOptions();
      const { selectedIndex } = this.state;
      if (this.state.showSuggestions &&
          options.length > 0 && selectedIndex >= 0) {
        this.onChange(e, options[selectedIndex].value);
        this.setState({ showSuggestions: false });
        e.preventDefault();
      }
    } else if (e.key === 'Tab') {
      this.setState({ showSuggestions: false });
    }
    if (this.props.onKeyDown) this.props.onKeyDown(e);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.hideSuggestions();
    }
  }

  filteredOptions() {
    const { value } = this.props;
    return this.props.options.filter(
      e => e.value.startsWith(value) ||
           (e.title && e.title.toLowerCase().startsWith(value))
    ).filter(e => e.value !== value);
  }

  hideSuggestions() {
    this.setState({ selectedIndex: -1, showSuggestions: false });
  }

  moveCursor(offset) {
    this.setState(prevState => {
      const { selectedIndex } = prevState;
      const options = this.filteredOptions();
      const lastIndex = options.length - 1;
      let nextIndex = selectedIndex + offset;
      if (nextIndex > lastIndex) nextIndex = 0;
      if (nextIndex > lastIndex) nextIndex = 0;
      else if (nextIndex < 0) nextIndex = lastIndex;
      if (options.length > 0) {
        // Scroll element into view if necessary
        const containerBounds = this.suggestionsContainer
                                    .current
                                    .getBoundingClientRect();
        const selectedNode = this[`${options[nextIndex].value}_ref`].current;
        const selectedNodeTop = selectedNode.getBoundingClientRect().top;
        if (selectedNodeTop - containerBounds.height > containerBounds.height ||
            selectedNodeTop < containerBounds.height) {
          selectedNode.scrollIntoView();
        }
      }
      return { selectedIndex: nextIndex };
    });
  }

  showSuggestions() {
    this.setState({ showSuggestions: true });
  }

  updateRefs() {
    this.filteredOptions().map(option => {
      this[`${option.value}_ref`] = React.createRef();
      return option;
    });
  }

  render() {
    const rest = omit(this.props, 'onChange', 'onKeyDown', 'options');
    const { selectedIndex, showSuggestions } = this.state;
    const options = this.filteredOptions();
    return (
      <div onFocus={this.showSuggestions} ref={this.setWrapperRef}>
        <Input
          onChange={this.onInputChange}
          onKeyDown={this.onKeyDown}
          {...rest}
        />
        {showSuggestions && options.length > 0 &&
          <div className={styles.suggestions} ref={this.suggestionsContainer}>
            {options.map((option, index) =>
              <div
                key={option.value}
                ref={this[`${option.value}_ref`]}
                onClick={e => this.onChange(e, option.value)}
                onMouseEnter={() => this.setState({ selectedIndex: index })}
              >
                <Suggestion
                  title={option.title}
                  description={option.description}
                  active={index === selectedIndex}
                />
              </div>
            )}
          </div>}
      </div>
    );
  }
}

export default InputWithSuggestions;



// WEBPACK FOOTER //
// ./webpack/components/Elements/InputWithSuggestions/InputWithSuggestions.js